import Ajax from "base/Ajax";
import Throttle from "base/Throttle";
import $ from "jquery";
import {EventEmitterStatic} from "base/EventEmitter";
import LoginModal from "login/LoginModal";
import AlertModal from "modal/AlertModal";

class SessionTracker extends EventEmitterStatic {

    static start() {
        if (!this.emit("start")) return;

        this.stop();

        this.interval = setInterval(this.check.bind(SessionTracker), 60 * 1000 /* One Minute */);
        this.check();

        $("body").on("change keypress keydown click", this.throttledRenew);
    }

    static stop() {
        if ("number" === typeof this.interval) {
            if (!this.emit("stop")) return;
            clearInterval(this.interval);
            this.interval = null;

            $("body").off("change keypress keydown click", this.throttledRenew);
        }
    }

    static check() {
        Ajax.get("adminUsers", "login").then((data) => {

            if (!data.loggedIn) {
                this.stop();
                if (this.warningModal) {
                    this.warningModal.destroy();
                }
                let modal = new LoginModal({destroyOnClose: true});
                modal.on("cancel close", () => window.location.reload());
                modal.on("logged-in", () => {
                    modal.destroy()
                });
                modal.show();
            } else if (data.expires.timestamp < ((new Date).getTime() / 1000) + 3 * 60 /* 3 Minutes*/) {
                this.warningModal = AlertModal.alert('Your session will expire soon, please interact with the page to renew it', 'Your session will expire soon');
            }
        });
    }

    static renew() {
        Ajax.put("adminUsers", "login");
        if (this.warningModal) {
            this.warningModal.destroy();
        }
    }

}

SessionTracker.throttledRenew = Throttle(SessionTracker.renew.bind(SessionTracker), 3 * 60 * 1000); //Run at most once every 3 minutes

export default SessionTracker;
